import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { NavbarComponent } from './navbar/navbar.component';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from 'src/app/shared/shared.module';
import { StatusBarComponent } from './navbar/status-bar/status-bar.component';
import { StatusBarNodeComponent } from './navbar/status-bar/status-bar-node/status-bar-node.component';

@NgModule({
  declarations: [NavbarComponent, StatusBarComponent, StatusBarNodeComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    SharedModule,
  ],
  exports: [NavbarComponent],
})
export class CoreModule {}
